<template>
  <div class="fit-content">
    <div>
      <DataTableDeCrud
        :items="icmss"
        :headers="headers"
        :rotina-id="ID_TELA_DE_ICMS"
        :configurar="false"
        :loading="loading"
        :busca-param="buscaParam"
        @create="() => abrirDialogCriarICMS()"
        @update="(indice) => abrirDialogEditarICMS(indice)"
        @delete="(indice) => openDialogDeleteICMS(indice)"
      />
      <DialogDeEdicaoDeICMS
        :operacao="operacao"
        :show-dialog.sync="showDialogParam"
        :icms-param="icmsParam"
        :itens="itensParam"
        @confirmado="atualizarICMS"
      />
      <SnackbarMessage
        :show-snack.sync="snackbar.showSnackParam"
        :snack-text="snackbar.snackTextParam"
        :snack-type="snackbar.snackTypeParam"
      />

      <v-dialog v-model="dialogDeleteICMS" persistent max-width="380">
        <v-card>
          <v-card-title class="headline">Excluir</v-card-title>
          <v-card-text refs="icmsDelete">
            Tem certeza que deseja excluir o ICMS <b> {{ icmsDelete.descricao }} </b>?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="dialogDeleteICMS = false">Cancelar</v-btn>
            <v-btn color="green darken-1" text @click="removerICMS">Confirmar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import ICMSService from '../../../services/icms/icms'
import SnackbarMessage from '../../../components/SnackbarMessage'
import DialogDeEdicaoDeICMS from '../../../components/icmss/DialogDeEdicaoDeICMS'
import DataTableDeCrud from '../../../components/DataTableDeCrud'
import SnackBar from '../../../models/components/snackbar'
import ICMS from '../../../models/icms'
import UFService from '../../../services/uf/uf'
import NCMService from '../../../services/ncm/ncm'
import LeiService from '../../../services/lei/lei'
import CSTService from '../../../services/cst/cst'
import { ID_TELA_DE_ICMS } from '@/common/constants'

export default {
  components: {
    SnackbarMessage,
    DataTableDeCrud,
    DialogDeEdicaoDeICMS
  },

  props: ['buscaParam'],

  data: () => ({
    name: 'TelaDeCEST',
    headers: [
      { text: 'Descrição', value: 'descricao' },
      { text: 'ICMS Original', value: 'icmsOriginal' },
      { text: 'ICMS Saída', value: 'icmsSaida' },
      { text: 'MVA', value: 'mva' },
      { text: 'Observacao', value: 'observacao' },
      { text: 'UF', value: 'uf.sigla' },
      { text: 'NCM', value: 'ncm.codigo' },
      { text: 'Lei', value: 'lei.codigo' },
      { text: 'CST', value: 'cst.codigo' }
    ],
    icmss: [],
    loading: false,
    validForm: false,
    dialog: false,
    operacao: '',
    showDialogParam: false,
    icmsParam: new ICMS(),
    itensParam: {},
    snackbar: new SnackBar(),
    dialogDeleteICMS: false,
    icmsDelete: new ICMS(),
    indiceICMSDelete: 0,
    itensUF: [],
    itensNCM: [],
    itensLei: [],
    itensCST: [],
    ID_TELA_DE_ICMS: ID_TELA_DE_ICMS
  }),

  created() {
    this.initialize()
  },

  methods: {
    initialize() {
      try {
        if (this.$route.query.id) {
          ICMSService.getById(this.$route.query.id).then((response) => this.icmss.push(response))
        } else {
          this.loadICMSs()
        }

        this.loadUFs()
        this.loadNCMs()
        this.loadLeis()
        this.loadCSTs()
      } catch (error) {
        this.snackbar.snackTextParam = 'Não foi possível encontrar ICMSs cadastrados.'
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      }
    },

    async loadICMSs() {
      this.loading = true
      const response = await ICMSService.getAll()
      this.icmss = response.map((item) => ({
        ...item
      }))
      this.loading = false
    },

    async loadUFs() {
      const response = await UFService.getAll()
      this.itensUF = response.map((item) => ({
        text: item.sigla,
        value: item.id
      }))
    },

    async loadNCMs() {
      const response = await NCMService.getAll()
      this.itensNCM = response.map((item) => ({
        text: item.codigo + ' - ' + item.descricao,
        value: item.id
      }))
    },

    async loadLeis() {
      const response = await LeiService.getAll()
      this.itensLei = response.map((item) => ({
        text: item.codigo + ' - ' + item.nome,
        value: item.id
      }))
    },

    async loadCSTs() {
      const response = await CSTService.getAll()
      this.itensCST = response.map((item) => ({
        text: item.codigo + ' - ' + item.descricao,
        value: item.id
      }))
    },

    atualizarICMS(icms) {
      if (!icms) return

      const indice = this.icmss.findIndex((icmsExistente) => icmsExistente.id === icms.id)

      if (indice === -1) {
        this.icmss.push(icms)
        this.snackbar.snackTextParam = 'ICMS criado com sucesso.'
      } else {
        this.icmss.splice(indice, 1, icms)
        this.snackbar.snackTextParam = 'ICMS atualizado com sucesso.'
      }

      this.snackbar.snackTypeParam = 'sucess'
      this.snackbar.showSnackParam = true
    },

    openDialogDeleteICMS(indice) {
      this.icmsDelete = this.icmss[indice]
      if (!this.icmsDelete.id) return

      this.indiceICMSDelete = indice
      this.dialogDeleteICMS = true
    },

    async removerICMS() {
      try {
        await ICMSService.deleteById(this.icmsDelete.id)
        this.snackbar.snackTextParam = 'ICMS removido com sucesso.'
        this.snackbar.snackTypeParam = 'sucess'
        this.snackbar.showSnackParam = true
        this.icmss.splice(this.indiceICMSDelete, 1)
      } catch (error) {
        this.snackbar.snackTextParam = `${error.response.status} | ${
          error.response.data.message === undefined
            ? error.message
            : error.response.data.message
            ? error.response.data.message
            : 'Ocorreu um erro durante o processo.'
        }`
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      }
      this.dialogDeleteICMS = false
    },

    abrirDialogCriarICMS() {
      this.operacao = 'adicionar'
      this.itensParam = {
        uf: this.itensUF,
        ncm: this.itensNCM,
        lei: this.itensLei,
        cst: this.itensCST
      }
      this.icmsParam = new ICMS()
      this.showDialogParam = true
    },

    abrirDialogEditarICMS(indice) {
      this.operacao = 'editar'
      this.itensParam = {
        uf: this.itensUF,
        ncm: this.itensNCM,
        lei: this.itensLei,
        cst: this.itensCST
      }
      this.icmsParam = { ...this.icmss[indice] }
      this.showDialogParam = true
    }
  }
}
</script>
